import { styled } from "@mui/material/styles";

const StyledPaymentSetup = styled("div")(
  ({ theme }) => `
  .payment-setup-header {
    font-family: Lexend;
    color: ${theme.palette.primary.main};
    font-weight: 400;
    font-size: 32px;
    font-style: normal;
    line-height: 40px;
    margin-top: 20px;
  }
  .payment-setup-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    border: 1px solid ${theme.palette.customColor.secondaryFirst};
    background: ${theme.palette.customColor.secondaryFirst};
    padding: 20px;
    @media screen and (max-width: 600px) and (min-width: 300px) {
      flex-direction: column-reverse;
    }
  }
    .payment-setup-image {
      @media screen and (max-width: 600px) and (min-width: 300px) {
      margin: 0px auto;
    }
    }
    .payment-setup-body {
      width: 70%;
    }
    .payment-body-header {
    font-family: "Lexend";
    color: ${theme.palette.primary.secondary};
    font-weight: 600;
    font-size: 18px;
    font-style: normal;
    line-height: 23px;
    }
    .payment-body-text {
    margin-top: 10px;
    font-family: Lexend;
    color: ${theme.palette.customColor.secondarySecond};    
    font-weight: 400;
    font-size: 14px;
    font-style: normal;
    line-height: 21px;
    }
    .account-details-wrap {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    }
    .account-deatils {
      display: flex;
      align-items: center;
      gap: 10px;
      @media screen and (max-width: 600px) and (min-width: 300px) {
        flex-direction: column;
        width: fit-content;
        align-items: flex-start;
      }
    }
    .account-deatils-line {
      width: 20px;
      height: 2px;
     background: ${theme.palette.customColor.secondaryThird};
     transform: rotate(90deg);
     @media screen and (max-width: 600px) and (min-width: 300px) {
       display: none;
     }
    }
    .account-name {
      font-family: Lexend;
      color: ${theme.palette.primary.main};
      font-weight: 400;
      font-size: 16px;
      font-style: normal;
      line-height: 20px;
    }
    .account-number-text {
      font-family: Lexend;
      color: ${theme.palette.primary.main};
      font-weight: 400;
      font-size: 16px;
      font-style: normal;
      line-height: 20px;
    };         
    .success-text {
      font-family: Lexend;
      color: ${theme.palette.customColor.secondarySecond};
      font-weight: 400;
      font-size: 14px;
      font-style: normal;
      line-height: 21px;
    }   
  `
);

export default StyledPaymentSetup;
